import Service from './Service';
import { format } from 'date-fns';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class ItemTabelaService extends Service {
  async consultarTabelas () {
    let tabelas = await this.getItemTabelaApi().consultarTabelas();
    return tabelas || [];
  }
  async consultarTiposDeItem () {
    let tipos = await this.getItemTabelaApi().consultarTiposDeItem();
    return tipos || [];
  }
  async consultarItens (codTabela, codItem, desItem, codTipo, indApenasUnimed) {
    let itens = [];
    let arrayVigencias = [];
    const nf = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    let result = await this.getItemTabelaApi().consultarItens(codTabela, codItem, desItem, codTipo, indApenasUnimed);
    result.map(res => {
      const { codItem, desItem, tipoItem, tabela, capitulo, grupo, subGrupo, txtObservacao, vigencias } = res;
      for (var i = 0; i < vigencias.length; i++) {
        if (tabela !== 'Tabela SIMPRO'){
          if (vigencias[i].indCancelado === 'S') {
            if (vigencias[i].dtaFim === null) {
              arrayVigencias.push('*Cancelada* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
            } else {
              arrayVigencias.push('*Cancelada* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
            }
          } else {
            if (vigencias[i].dtaFim === null) {
              arrayVigencias.push('* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
            } else {
              arrayVigencias.push('* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
            }
          }  
        } else {
          if (vigencias[i].indCancelado === 'S') {
            if (vigencias[i].dtaFim === null) {
              if (vigencias[i].valIntegral !== null) {
                arrayVigencias.push('*Cancelada* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) +  ' - ' + vigencias[i].grupoPrestador);
              } else {
                arrayVigencias.push('*Cancelada* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              }
            } else {
              if (vigencias[i].valIntegral !== null) {
                arrayVigencias.push('*Cancelada* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) + ' - ' + vigencias[i].grupoPrestador);
              } else {
                arrayVigencias.push('*Cancelada* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              }
              
            }
          } else {
            if (vigencias[i].dtaFim === null) {
              if (vigencias[i].valIntegral !== null) {
                arrayVigencias.push('* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) + ' - ' + vigencias[i].grupoPrestador);
              } else {
                arrayVigencias.push('* Desde ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);                
              }
            } else {
              if (vigencias[i].valIntegral !== null) {
                arrayVigencias.push('* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - Integral: ' +  nf.format(vigencias[i].valIntegral) + ' - ' + vigencias[i].grupoPrestador);
              } else {
                arrayVigencias.push('* De ' + format(new Date(vigencias[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(vigencias[i].dtaFim), 'DD/MM/YYYY') + ' - ' + nf.format(vigencias[i].valVigencia) + ' - ' + vigencias[i].grupoPrestador);
              }
            }
          }  
        }
      }
      itens.push(Object.values({ codItem, desItem, tipoItem, tabela, capitulo, grupo, subGrupo, arrayVigencias, txtObservacao }));
      arrayVigencias = [];
    });
    return itens || [];
  }
}
export default ItemTabelaService;
